<template>
    <div>
        <h3>{{$t('instance.instance_details.instance_administrator.administrator_title')}}</h3>
        <v-text-field
            v-model="instance.user_administrator.email"
            label="Email"
            :disabled="true"
        ></v-text-field>
        <v-alert
            class="alert-content"
            color="#FFF3E0"
            icon="info"
            border="top"
        >
            {{$t('instance.instance_details.instance_administrator.administrator_description')}}
        </v-alert>
    </div>
</template>

<script>
export default {

    name: 'administrator-details',

    props:{
        instance:{
            type: Object,
            required: true,
        },
    },

    data () {
        return {
        };
    },
};
</script>

<style lang="css" scoped>
.alert-content{
    color: #FF9800;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceDetails/administrator-details.vue